import {MarketerRepositoryImpl} from '../repository/MarketerRepositoryImpl';
import {GetMarketersInBoundsUseCase} from '../useCases/GetMarketersInBoundsUseCase';
import {SelectMarketerUseCase} from '../useCases/SelectMarketerUseCase';
import {GetAllMarketersUseCase} from '../useCases/GetAllMarketersUseCase';
import {CreateMarketerUseCase} from '../useCases/CreateMarketerUseCase';
import {GetAllMarketersWithoutPaginationUseCase} from '../useCases/GetAllMarketersWithoutPaginationUseCase';
import {DeleteMarketerUseCase} from '../useCases/DeleteMarketerUseCase';
import {UpdateMarketerProfileUseCase} from '../useCases/UpdateMarketerProfileUseCase';
import {UpdateMarketerPasswordUseCase} from '../useCases/UpdateMarketerPasswordUseCase';
import {MapService, MapboxMapService} from '../../../Services/map/MapService';

// Factory class for Marketers feature
export class MarketersFactory {
  private static marketersRepository: MarketerRepositoryImpl | null = null;
  private static mapService: MapService | null = null;

  // Repository Singleton
  private static getMarketersRepository (): MarketerRepositoryImpl {
    if (!this.marketersRepository) {
      this.marketersRepository = new MarketerRepositoryImpl();
    }
    return this.marketersRepository;
  }

  // Map Service Singleton
  private static getMapService (): MapService {
    if (!this.mapService) {
      this.mapService = MapboxMapService.getInstance();
    }
    return this.mapService;
  }

  // Use Cases Factory Methods
  static createGetMarketersInBoundsUseCase (): GetMarketersInBoundsUseCase {
    const mapService = this.getMapService();
    return new GetMarketersInBoundsUseCase(mapService);
  }

  static createSelectMarketerUseCase (): SelectMarketerUseCase {
    return new SelectMarketerUseCase();
  }

  static createGetAllMarketersUseCase (): GetAllMarketersUseCase {
    const repository = this.getMarketersRepository();
    return new GetAllMarketersUseCase(repository);
  }

  static createCreateMarketerUseCase (): CreateMarketerUseCase {
    const repository = this.getMarketersRepository();
    return new CreateMarketerUseCase(repository);
  }

  static createGetAllMarketersWithoutPaginationUseCase (): GetAllMarketersWithoutPaginationUseCase {
    return new GetAllMarketersWithoutPaginationUseCase();
  }

  static createDeleteMarketerUseCase (): DeleteMarketerUseCase {
    const repository = this.getMarketersRepository();
    return new DeleteMarketerUseCase(repository);
  }

  static createUpdateMarketerProfileUseCase (): UpdateMarketerProfileUseCase {
    const repository = this.getMarketersRepository();
    return new UpdateMarketerProfileUseCase(repository);
  }

  static createUpdateMarketerPasswordUseCase (): UpdateMarketerPasswordUseCase {
    const repository = this.getMarketersRepository();
    return new UpdateMarketerPasswordUseCase(repository);
  }

  // Reset factory (useful for testing)
  static reset (): void {
    this.marketersRepository = null;
    this.mapService = null;
  }
}
